import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faTimesCircle,
  faEdit,
  faCopy,
  faLink,
  faCheckCircle,
  faArrowDown,
  faArrowUp,
  faCheck,
  faInfo,
  faInfoCircle,
  faEye,
  faGift,
  faFileExport,
  faPlayCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faShoppingBasket,
  faFileInvoiceDollar,
  faStar,
  faUserCircle,
  faShoppingBag,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faSpinner,
  faTimesCircle,
  faEdit,
  faCopy,
  faLink,
  faCheckCircle,
  faArrowDown,
  faArrowUp,
  faCheck,
  faInfo,
  faInfoCircle,
  faEye,
  faGift,
  faFileExport,
  faPlayCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faShoppingBasket,
  faFileInvoiceDollar,
  faStar,
  faUserCircle,
  faShoppingBag,
  faSignOutAlt,
);



// WEBPACK FOOTER //
// ./src/plugins/font-awesome.js